/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { NotFoundComponent } from './not-found/not-found.component';
import {SanitizeHtmlPipe} from './pipes/sanitize-html.pipe';
import { ProgressIndicatorComponent } from './progress-indicator/progress-indicator.component';
import { CurrencyFormatterDirective } from './directives/currency-formatter.directive';
import { RestrictSpecialCharacterDirective } from './directives/restrict-special-character.directive';
import { OutageMessageComponent } from './outage-message/outage-message.component';
import { LogoutPromptComponent } from './logout-prompt/logout-prompt.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { DialogModule } from '@kpmg-ux/ngx-tax-design-system';



@NgModule({
  imports: [
    CommonModule,
    SharedRoutingModule,
    DialogModule
  ],
  declarations: [NotFoundComponent, AccessDeniedComponent, SanitizeHtmlPipe, ProgressIndicatorComponent, CurrencyFormatterDirective, RestrictSpecialCharacterDirective, OutageMessageComponent, LogoutPromptComponent],
  exports: [SanitizeHtmlPipe, ProgressIndicatorComponent,CurrencyFormatterDirective,RestrictSpecialCharacterDirective,OutageMessageComponent, LogoutPromptComponent]
})
export class SharedModule { }
